// @flow

import React, { Component, Fragment } from 'react';
import connect from '@active/awe-ui-core/lib/hoc/connect';
import L10nMessage from 'react-aaui/lib/shared/L10nMessage';
import { bindActionCreators } from 'redux';
import Form from 'react-aaui/lib/form/Form';
import VField from 'react-aaui/lib/form/VField';
import TextInput from 'react-aaui/lib/form/TextInput';
import EmailInput from 'react-aaui/lib/form/EmailInput';
import TextArea from 'react-aaui/lib/form/TextArea';
import Button from 'react-aaui/lib/Button';
import injectL10n from 'react-aaui/lib/shared/injectL10n';
import { closePopup } from 'components/Popup/duck/duck';
import {
  getEnterprisePersonId, isLoginUser, getUserEmail, getUserName,
} from 'modules/user/selector';
import { getParticipantExternalId, getEvent, isSavingIssue } from '../duck/selector';
import { reportIssue } from '../duck/duck';
import '../duck/epics';
import './IssueReportPopup.scss';

type Props = {
  onCancel: Function,
  onSave: Function,
  hasLogin: boolean,
  enterprisePersonId: ?string,
  applicationName: string,
  participantId: string,
  detail: ?string,
  loginUserName: ?string,
  loginUserEmail: ?string,
  savingIssue: boolean,
  participantLongId: ?number
}

export class IssueReportPopup extends Component<Props> {
  onSubmit = (fields: any) => {
    const { detail, reporterName, reporterEmail } = fields;
    const {
      enterprisePersonId, participantId,
      applicationName, loginUserEmail,
      loginUserName, participantLongId,
    } = this.props;

    this.props.onSave({
      detail,
      reporterEmail: reporterEmail || loginUserEmail,
      reporterName: reporterName || loginUserName,
      reporterEPId: enterprisePersonId,
      applicationName,
      participantId,
      participantLongId,
    });
  }

  render() {
    const {
      detail, loginUserName, loginUserEmail, onCancel, hasLogin, savingIssue,
    } = this.props;
    const fields = {
      detail,
      reporterName: loginUserName,
      reporterEmail: loginUserEmail,
    };
    return (
      <Form className="report-issue-popup__form form--horizontal" fields={fields} onSubmit={this.onSubmit}>
        <div className="modal-body">
          <div className="report-issue-popup__editor">
            <VField name="detail" label="page.event.individual.issue.report.detail" component={TextArea} rows="8" maxLength="3000" required />
            {!hasLogin
            && <Fragment>
              <VField name="reporterName" label="page.event.individual.issue.reporter.name" component={TextInput} maxLength="255" required />
              <VField name="reporterEmail" label="page.event.individual.issue.reporter.email" component={EmailInput} maxLength="255" required />
            </Fragment>}
          </div>
        </div>
        <div className="modal-footer">
          <Button className="report-issue-popup__btn-cancel" noSubmit onClick={onCancel}><L10nMessage id="react-aaui.cancel" /></Button>
          <Button className="report-issue-popup__btn-save" type="primary" disabled={savingIssue} loading={savingIssue}>
            <L10nMessage id="button.submit" />
          </Button>
        </div>
      </Form>
    );
  }
}

const mapState = (state) => {
  return {
    hasLogin: isLoginUser(state),
    enterprisePersonId: getEnterprisePersonId(state),
    participantId: getParticipantExternalId(state),
    applicationName: getEvent(state).get('applicationName'),
    detail: '',
    loginUserName: getUserName(state),
    loginUserEmail: getUserEmail(state),
    savingIssue: isSavingIssue(state),
  };
};

const mapDispatch = dispatch => bindActionCreators({
  onCancel: closePopup,
  onSave: reportIssue,
}, dispatch);

export default injectL10n()(connect(mapState, mapDispatch)(IssueReportPopup));
